export const STATUS = {
  IDLE: 'idle', // 游戏未开始
  GAMING: 'gaming', // 游戏中
}